import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpUtilService } from "../http-util.service";

const SERVICE_NAME = "BookingService.asmx";

@Injectable({
  providedIn: "root"
})
export class ParfTransferDateService {
  constructor(private http: HttpUtilService) {}

  getParfDetails(contractNo: string): Observable<any> {
    const encodedContractNo = encodeURIComponent(`"${contractNo}"`);
    return this.http.get(`/${SERVICE_NAME}/GetParfDetails?contractNo=${encodedContractNo}`);
  }

  updateParfDate(contractNo: string, transferDate: string): Observable<any> {
    const payload = {
      model: {
        Name: contractNo,
        Value: transferDate
      }
    };
    return this.http.post(`/${SERVICE_NAME}/UpdateParfDate`, payload);
  }
}
